import { useEffect, useState, useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';

import { getAllTreatingOrgs } from 'api/treating_orgs';
import { createPsadRep } from 'api/psad_reps';

import Input from 'components/input/input';
import Select from 'components/select/select';

import { ReactComponent as ArrowRightSVG } from 'icons/arrow-right.svg';

const PsadRepAdd = () => {
  const [allTreatingOrgs, setAllTreatingOrgs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [psadRep, setPsadRep] = useState({});
  const [isValid, setIsValid] = useState({
    firstName: true,
    lastName: true,
    email: true,
    treatingOrg: true,
  });
  const history = useHistory();

  useEffect(() => {
    (async () => {
      const allTreatingOrgs = await getAllTreatingOrgs();

      setAllTreatingOrgs(allTreatingOrgs);
    })();
  }, []);

  const onChange = (e) => {
    const { name, value } = e.target;

    setPsadRep({
      ...psadRep,
      [name]: value,
    });
  };

  const onSelectChange = (field, selectedOption) => {
    setPsadRep({
      ...psadRep,
      [field]: selectedOption,
    });
  };

  const checkValidity = () => {
    const validation = {
      firstName: !!psadRep.firstName,
      lastName: !!psadRep.lastName,
      email: !!psadRep.email,
      treatingOrg: !!psadRep.treatingOrg,
    };

    setIsValid(validation);

    return Object.values(validation).every(Boolean);
  };

  const onSubmit = useCallback(async () => {
    setLoading(true);

    if (checkValidity()) {
      const newPsadRep = await createPsadRep({
        ...psadRep,
        treatingOrg: psadRep.treatingOrg?.id,
      });

      setLoading(false);

      history.push(`/psad_reps/${newPsadRep.id}`);
    } else {
      setIsValid(checkValidity);
      setLoading(false);
    }
  }, [history, psadRep]);

  if (loading) return <main className="th-main"></main>;

  return (
    <main className="th-main">
      <section className="th-canvas">
        <header className="th-canvas-header">
          <h2 className="th-canvas-title">
            <Link to="/psad_reps">PSAD representatives</Link>
            <span>
              <ArrowRightSVG />
            </span>
            Add
          </h2>
          <section className="view-actions">
            <button className="btn-green" data-cy="submit" onClick={onSubmit}>
              Submit
            </button>
          </section>
        </header>
        <div>
          <h4 className="midlightgrey f-small fw5 ttu mt15">Details</h4>
          <div className="pa5 pt4 br4 shadow-1 bg-grouped-table mt2 flex flex-column items-start justify-between">
            <div className="w-100 flex flex-column">
              <div className="w-100 flex flex-row items-start justify-between margin-between">
                <div className="w-100">
                  <div className="w-100 flex flex-row justify-between margin-between">
                    <div className="w-50">
                      <Input
                        name="firstName"
                        label="First name*"
                        value={psadRep.firstName}
                        valid={isValid.firstName}
                        onChange={(event) => onChange(event)}
                      />
                    </div>
                    <div className="w-50">
                      <Input
                        name="lastName"
                        label="Last name*"
                        value={psadRep.lastName}
                        valid={isValid.lastName}
                        onChange={(event) => onChange(event)}
                      />
                    </div>
                  </div>
                  <div className="w-100 flex flex-row justify-between margin-between">
                    <div className="w-50">
                      <Input
                        name="email"
                        label="Email*"
                        value={psadRep.email}
                        valid={isValid.email}
                        onChange={(event) => onChange(event)}
                      />
                    </div>
                    <div className="w-50">
                      <Input
                        name="phone"
                        label="Phone number"
                        value={psadRep.phone}
                        valid={true}
                        onChange={(event) => onChange(event)}
                      />
                    </div>
                  </div>
                  <div className="w-100 flex flex-row justify-between margin-between">
                    <div className="w-100">
                      <Select
                        className="treating-org-select"
                        valid={isValid.treatingOrg}
                        isMulti={false}
                        label="Treating organisation*"
                        value={psadRep.treatingOrg}
                        options={allTreatingOrgs.map((t) => ({
                          id: t.id,
                          value: t.id,
                          label: t.name,
                        }))}
                        onChange={(selectedOption) =>
                          onSelectChange('treatingOrg', selectedOption)
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default PsadRepAdd;
